module.exports = "\n    <select  #input  [(ngModel)]=\"value\" style=\"    width: 150px;\n    height: 25px;\n    font-size: 13px;\">\n        <option *ngFor=\"let item of options\" value=\"{{item.value}}\">{{item.name}}</option>\n    </select>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/cs/views/drop-down-editor/drop.down.editor.html
// module id = ./src/app/cs/views/drop-down-editor/drop.down.editor.html
// module chunks = main